module.exports = __webpack_public_path__ + "img/icon0.1cac738f.png";